import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    StyleSheet,
    Image,
    Platform
} from 'react-native';
import {
    JDTouchable,
    JDText,
    JDScrollView,
    JDLogin,
    JDImage
} from '@jdreact/jdreact-core-lib';
import { ImageList as ImageInfos, NavBar, utils } from '@ltfe/ltfe-core-lib';

import ImageViewer from 'react-native-image-zoom-viewer';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import EvaluationItem from '../components/common/evaluation-item';
import Loading from '../components/common/loading';
import WifiOut from '../components/common/wifi-out';
import Stars from '../components/stars';
import Share from '../components/right-share';
import More from '../components/right-more';
import Menu from '../components/menu';
import ToIndex from '../components/common/to-index';

import st from '../style/movie-detail';

import { get } from '../common/fetch';
import { tip, getLabel, getNum, getByteLen, clip, actorType, mta, mtaPV } from '../common/utils';
import sgmReport from '../common/sgmUtil';

const len = 120;
const { pt, store } = utils;

class BoxOffice extends PureComponent {
    render() {
        const { boxOffice } = this.props;

        if (!boxOffice.dayOneAmount && !boxOffice.weekOneAmount && !boxOffice.totalAmount) {
            return null;
        }

        return (
            <View style={ st.box_office }>
                {!!boxOffice.dayOneAmount &&
                    <View style={ st.box_office_part }>
                        <JDText style={ st.box_office_value }>{boxOffice.dayOneAmount}</JDText>
                        <JDText style={ st.box_office_label }>首日票房</JDText>
                    </View>
                }
                {!!boxOffice.weekOneAmount &&
                    <View style={ st.box_office_part }>
                        <JDText style={ st.box_office_value }>{boxOffice.weekOneAmount}</JDText>
                        <JDText style={ st.box_office_label }>首周票房</JDText>
                    </View>
                }
                {!!boxOffice.totalAmount &&
                    <View style={ st.box_office_part }>
                        <JDText style={ st.box_office_value }>{boxOffice.totalAmount}</JDText>
                        <JDText style={ st.box_office_label }>累计票房</JDText>
                    </View>
                }
            </View>
        );
    }
}

class Actor extends PureComponent {
    render() {
        const { actor, showActor } = this.props;

        return (
            <JDTouchable activeOpacity={ 0.5 } style={ st.actor } onPress={ () => showActor(actor) }>
                <JDImage source={ /* img.bg */{ uri: actor.jdPhoto } } style={ st.actor_photo } />
                <JDText style={ st.actor_name } numberOfLines={ 1 } ellipsizeMode={ 'tail' }>{/* 是枝裕和 */}{actor.name}</JDText>
                <JDText style={ st.actor_role } numberOfLines={ 1 } ellipsizeMode={ 'tail' }>{actorType[actor.role]}</JDText>
            </JDTouchable>
        );
    }
}

class ActorMovie extends PureComponent {
    render() {
        const { movie } = this.props;

        return (
            <JDTouchable activeOpacity={ 0.5 } contentContainerStyle={ st.actor_info_more_info } onPress={ this.goMovieDetail }>
                {!!movie.jdPicUrl &&
                    <JDImage source={ { uri: movie.jdPicUrl } } style={ st.actor_info_more_image } />
                }
                <View style={ st.actor_info_more_info_content } >
                    <View style={ st.actor_info_more_info_header }>
                        <JDText style={ st.actor_info_more_info_name }>{movie.movieName}</JDText>
                        {!!(movie.showType && movie.showType.split('-').length === 1) &&
                            <View style={ st.label_all }>
                                <JDText style={ st.label_one_text }>{movie.showType}</JDText>
                            </View>
                        }
                        {!!(movie.showType && movie.showType.split('-').length === 2) &&
                            <View style={ st.label }>
                                <View style={ st.label_one }>
                                    <JDText style={ st.label_one_text }>{movie.showType.split('-')[0]}</JDText>
                                </View>
                                <View style={ st.label_two }>
                                    <JDText style={ st.label_two_text }>{movie.showType.split('-')[1]}</JDText>
                                </View>
                            </View>
                        }
                    </View>
                    {!!movie.like &&
                        <View style={ st.actor_info_more_info_look }>
                            <JDText style={ st.actor_info_more_info_look_one }>{getNum(movie.like)}
                                <JDText style={ st.actor_info_more_info_look_two }>人想看</JDText>
                            </JDText>
                        </View>
                    }
                    {!!movie.actors &&
                        <JDText style={ st.actor_info_more_info_actors }>{movie.actors}</JDText>
                    }
                    {!!movie.releaseDate &&
                        <JDText style={ st.actor_info_more_info_show }>{movie.releaseDate} 在中国大陆上映</JDText>
                    }
                </View>
            </JDTouchable>
        );
    }

    goMovieDetail = () => {
        const { movie, actorShow, info } = this.props;

        mta('ActorRelatedMov', 'Info', `${actorShow.name}_${info.jSkuId}_${info.movieId}`);
        this.context.router.toMovieDetail({ movieId: movie.movieId });
    }
}

ActorMovie.contextTypes = {
    router: PropTypes.object
};

class MovieDetail extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            hasError: false,
            info: {}, // 影片信息
            actorShow: null, // 要展示的演员信息
            actorMovies: null, // 演员影片列表
            introMoreShow: false, // 是否展开简介
            swiperShow: false, // 是否展示轮播图
            rateShow: false, // 是否展示评分
            index: 0, // 轮播图的索引
            rateScore: null, // 评分
            shareInfo: {}, // 分享信息
            isEvaluateShow: true
        };
    }

    render() {
        const { isLoading, hasError, info, actorShow, actorMovies, introMoreShow, swiperShow, rateShow, rateScore, index, shareInfo, isEvaluateShow } = this.state;
        const { scheduledPlay } = this.props;
        let imgs;

        if (info.stagePicInfo && info.stagePicInfo.length) {
            imgs = info.stagePicInfo.map((url) => ({ url: url.normalUrl }));
        }
        if (hasError) {
            return (
                <View style={ st.s_container }>
                    <WifiOut refresh={ () => this.getInfo() } contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                    {/* 开场提示 */}
                    {/* <OpeningHint ref={(hint) => this._hint = hint} /> */}
                </View>
            );
        }

        return (
            <View style={ st.s_container }>
                {/* 返回首页 */}
                <ToIndex />

                {
                    isLoading
                        ? <View style={ st.s_container }>
                            <Loading contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                        </View>
                        : <View style={ st.s_container }>
                           
                            {/* <NavigationBar Title={(!!info.movieName && (getByteLen(info.movieName) > 20 ? clip(info.movieName, 20) + '...' : info.movieName)) || '影片详情'} RightButton={() => <Share shareInfo={shareInfo} />} /> */}
                            <JDScrollView style={ st.body } showsVerticalScrollIndicator={ false } bounces={ false }>
                                {/* 基本信息 */}
                                <View style={ st.brief }>
                                    <Image className='blur' style={ [st.brief_bg, { opacity: '0.7' }] } blurRadius={ 10 } imageStyle={ { resizeMode: 'cover' } } source={ { uri: info.jdPicUrl } } />
                                    <View style={ st.brief_wrap }>
                                        <View style={ st.brief_info }>
                                            <JDText style={ st.brief_name } numberOfLines={ 1 }>{info.movieName}</JDText>
                                            <JDText style={ st.brief_english_name }>{info.englishName || ' '}</JDText>
                                            {/* 是否可预订 1: 预售 2 ：热映 3：想看     预售和想看显示想看人数， 热映显示评分/暂无评分 */}
                                            {!(info.canPreOrder === 2)
                                                ? <View style={ st.brief_like }>
                                                    <JDText style={ st.brief_like_one }>{getNum(info.wannaSeenNum)}
                                                        <JDText style={ st.brief_like_two }> 人想看</JDText>
                                                    </JDText>
                                                </View>
                                                : info.grade
                                                    ? <View style={ st.brief_score }>
                                                        <Stars score={ info.grade } />
                                                        <JDText style={ st.brief_score_text }>{info.grade}</JDText>
                                                    </View>
                                                    : <View style={ st.brief_score }>
                                                        <JDText style={ st.brief_score_text }>暂无评分</JDText>
                                                    </View>
                                            }
                                            <JDText style={ st.brief_item }>{info.movieType || ' '}</JDText>
                                            <JDText style={ st.brief_item }>{[info.area ? info.area : null, info.movieLength ? info.movieLength + '分钟' : null].filter(x => x).join(' | ') || ' '}</JDText>
                                            <JDText style={ st.brief_item }>{info.releaseDate} 在中国大陆上映</JDText>
                                        </View>
                                        {!!(info.jdPicUrl && !(info.trailerInfoVOS && info.trailerInfoVOS.length)) &&
                                            <View style={ st.video_bg_wrap }>
                                                <JDImage source={ { uri: info.jdPicUrl } } style={ st.video_bg } />
                                            </View>
                                        }
                                        {!!(info.jdPicUrl && info.trailerInfoVOS && info.trailerInfoVOS.length) &&
                                            <JDTouchable activeOpacity={ 0.5 } onPress={ () => this.goMovie(info.trailerInfoVOS[0]) } contentContainerStyle={ st.video_bg_wrap }>
                                                <JDImage source={ { uri: info.jdPicUrl } } style={ st.video_bg } />
                                                <JDImage source={ img.play } style={ st.video_play } />
                                            </JDTouchable>
                                        }
                                    </View>
                                </View>
                                {/* 功能区，想看 评分 */}
                                {/* 已评分/未评分 */}
                                {info.flag === 10 && info.starLevel
                                    ? <View style={ st.fns }>
                                        <View style={ st.evaluate }>
                                            <JDText style={ st.evaluate_label }>{getLabel(info.starLevel)}</JDText>
                                            <Stars score={ info.starLevel } size={ 15 } />
                                            <JDText style={ st.evaluate_score }>{info.starLevel.toFixed(1)}</JDText>
                                        </View>
                                    </View>
                                    : <View style={ st.fns }>
                                        {/* 已想看/未想看 */}
                                        {info.type === 10
                                            ? <JDTouchable activeOpacity={ 0.5 } onPress={ this.wannaSee }>
                                                <View style={ st.fn } >
                                                    <JDImage source={ img.heart_red } style={ st.fn_icon } />
                                                    <JDText style={ st.fn_text }>已想看</JDText>
                                                </View>
                                            </JDTouchable>
                                            : <JDTouchable activeOpacity={ 0.5 } onPress={ this.wannaSee }>
                                                <View style={ st.fn } >
                                                    <JDImage source={ img.heart } style={ st.fn_icon } />
                                                    <JDText style={ st.fn_text }>想看</JDText>
                                                </View>
                                            </JDTouchable>
                                        }
                                        <JDTouchable activeOpacity={ 0.5 } onPress={ this.showRate }>
                                            <View style={ st.fn }>
                                                <JDImage source={ img.star } style={ st.fn_icon } />
                                                <JDText style={ st.fn_text }>评分</JDText>
                                            </View>
                                        </JDTouchable>
                                    </View>
                                }
                                {/* 介绍 */}
                                {!!info.movieInfo &&
                                    <View style={ st.intro } >
                                        <JDText style={ st.intro_text } ellipsizeMode={ 'tail' } activeOpacity={ 1 } suppressHighlighting={ true } onPress={ this.toggleIntroMore }>
                                            {(getByteLen(info.movieInfo) > len && !introMoreShow) ? clip(info.movieInfo, len) + '... ' : info.movieInfo}
                                            {!!(getByteLen(info.movieInfo) > len) && <JDText style={ { color: '#2B84FF' } } >{!introMoreShow ? '展开' : '收起'}</JDText>}
                                        </JDText>
                                    </View>
                                }
                                {/* 演员 */}
                                {!!(info.actors && info.actors.length) &&
                                    <View style={ st.actors_wrap }>
                                        <JDText style={ st.actors_label }>演职人员</JDText>
                                        <JDScrollView style={ { height: pt(140) } } contentContainerStyle={ st.scroll_content } horizontal={ true } showsHorizontalScrollIndicator={ false }>
                                            {[...info.actors].map((actor, index) => (<Actor key={ index } actor={ actor } showActor={ this.showActor } />))}
                                        </JDScrollView>
                                    </View>
                                }
                                {/* 视频与图片 */}
                                <View style={ st.media_top }>
                                    {!!(info.trailerInfoVOS && info.trailerInfoVOS.length) &&
                                        <View style={ st.media_wrap }>
                                            <JDText style={ st.media_label }>视频({info.trailerInfoVOS.length})</JDText>
                                            <JDScrollView contentContainerStyle={ st.scroll_content } style={ [st.videos_wrap, { height: pt(126) }] } horizontal={ true } showsHorizontalScrollIndicator={ false }>
                                                {info.trailerInfoVOS.map((item, index) => (
                                                    <JDTouchable activeOpacity={ 0.5 } key={ index } onPress={ () => this.goMovie(item) } contentContainerStyle={ st.media_video }>
                                                        <JDImage source={ { uri: item.jdTrailerImgUrl } } style={ st.media_video_bg } />
                                                        <JDImage source={ img.play } style={ st.media_video_play } />
                                                    </JDTouchable>
                                                ))}
                                            </JDScrollView>
                                        </View>
                                    }
                                    {!!(info.stagePicInfo && info.stagePicInfo.length) &&
                                        <View style={ st.pic_wrap }>
                                            <JDText style={ st.media_label }>剧照({info.stagePicInfo.length})</JDText>
                                            <JDScrollView contentContainerStyle={ st.scroll_content } style={ [st.images_wrap, { height: pt(126) }] } horizontal={ true } showsHorizontalScrollIndicator={ false }>
                                                {info.stagePicInfo.map((item, index) => (
                                                    <JDTouchable activeOpacity={ 0.5 } key={ index } onPress={ () => this.showSwiper(index) }>
                                                        <JDImage source={ { uri: item.minUrl } } style={ st.media_image } />
                                                    </JDTouchable>
                                                ))}
                                            </JDScrollView>
                                        </View>
                                    }
                                </View>
                                {/* {!!info.movieBoxOfficeVO && <BoxOffice boxOffice={info.movieBoxOfficeVO} />} */}
                                {
                                    isEvaluateShow ? <EvaluationItem info={ info } hide={ this.getShow.bind(this) } /> : null
                                }
                                <ImageInfos code={ '85985dbf27314627ac7caae37d0eb618' } mode={ 'pro' } channel='movie' />
                            </JDScrollView>
                            {(+scheduledPlay === 1 || !!(info.buttonFlag)) &&
                                <JDTouchable activeOpacity={ 0.5 } style={ { marginBottom: iphoneXMarginBottom } } onPress={ this.goMovieSchedule }>
                                    <LinearGradient colors={ ['#F10000', '#FF2000', '#FF4F18'] } style={ st.footer } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                                        <JDText style={ st.pay }>特惠购票</JDText>
                                    </LinearGradient>
                                </JDTouchable>
                            }
                            {(+scheduledPlay !== 1 && !(info.buttonFlag)) &&
                                <JDTouchable activeOpacity={ 0.5 } style={ { marginBottom: iphoneXMarginBottom } } >
                                    <LinearGradient colors={ ['#F10000', '#FF2000', '#FF4F18'] } style={ st.footer } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                                        <JDText style={ st.pay }>即将开售</JDText>
                                    </LinearGradient>
                                </JDTouchable>
                            }
                            {/*  演员弹层 */}
                            {!!actorShow && (
                                <View style={ st.popup_info_wrap }>
                                    <JDTouchable activeOpacity={ 1 } style={ st.mask } onPress={ this.hideActor } />
                                    <View style={ st.popup_info } >
                                        {!!actorShow.name &&
                                            <JDText style={ st.actor_info_name }>{actorShow.name}</JDText>
                                        }
                                        <JDText style={ st.actor_info_alias }>{actorShow.englishName}</JDText>
                                        {/* {!!actorShow.introduction &&
                                            <JDText style={st.actor_info_intro}>{actorShow.introduction}</JDText>
                                        } */}
                                        {!!(actorMovies && actorMovies.length) &&
                                            <JDScrollView style={ st.actor_info_more } >
                                                <JDText style={ st.actor_info_more_text }>他的其它影片即将上映</JDText>
                                                {actorMovies.map((x, i) =>
                                                    <ActorMovie movie={ x } key={ i } actorShow={ actorShow } info={ info } />
                                                )}
                                            </JDScrollView>
                                        }
                                    </View>
                                    <JDTouchable activeOpacity={ 0.5 } onPress={ this.hideActor }>
                                        <JDImage style={ st.popup_close } source={ img.close } />
                                    </JDTouchable>
                                </View>
                            )}
                            {/*  评分弹层 */}
                            {!!rateShow && (
                                <View style={ st.popup_info_wrap }>
                                    <JDTouchable style={ st.mask } activeOpacity={ 1 } onPress={ this.hideRate } />
                                    <View style={ StyleSheet.flatten([st.popup_info, { alignItems: 'center' }]) } >
                                        <JDText style={ st.popup_info_title }>我的评分</JDText>
                                        <View style={ st.popup_info_rate_wrap }>
                                            {rateScore
                                                ? <JDText style={ st.popup_info_rate }>{Number(rateScore).toFixed(1)}
                                                    <JDText style={ st.popup_info_rate_addition }>分 | {getLabel(rateScore)}</JDText>
                                                </JDText>
                                                : <JDText style={ st.popup_info_sub }>期待您的评分</JDText>
                                            }
                                        </View>
                                        <View style={ { flexDirection: 'row' } }>
                                            <Stars score={ rateScore } size={ 40 } onPress={ this.rate } />
                                        </View>
                                        <JDTouchable activeOpacity={ 0.5 } style={ st.popup_info_submit_wrap } onPress={ this.submit }>
                                            <JDText style={ st.popup_info_submit }>提交</JDText>
                                        </JDTouchable>

                                    </View>
                                    <JDTouchable activeOpacity={ 1 } onPress={ this.hideRate }>
                                        <JDImage style={ st.popup_close } source={ img.close } />
                                    </JDTouchable>
                                </View>
                            )}
                            {/* 图片展示 */}
                            {!!swiperShow &&
                                <View style={ { position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 } }>

                                    <ImageViewer
                                        imageUrls={ imgs }
                                        index={ index }
                                        onClick={ this.hideSwiper } />

                                </View>
                            }
                            <Menu ref={ e => { this.refMenu = e; } } />
                        </View>
                }
                {/* 开场提示 */}
                {/* <OpeningHint ref={(hint) => this._hint = hint} /> */}

            </View>
        );
    }

    async componentDidMount() {
        try {
            await this.initCity();
            const { info } = this.state;
            const { movieId, jSkuId } = info;
            
            this.setTitle(!!info.movieName && (getByteLen(info.movieName) > 20 ? clip(info.movieName, 20) + '...' : info.movieName) || '影片详情')
            mtaPV('Info', `${movieId}_${jSkuId}`);
        } catch (e) {

        }
    }

    componentDidFocus() {
        // 开场提示
        // this._hint.hintStorage();
        if (this.state.info && this.state.info.movieId) {
            const { movieId, jSkuId } = this.state.info;

            mtaPV('Info', `${movieId}_${jSkuId}`);
        }
    }

    getShow = (boolean) => {
        this.setState({
            isEvaluateShow: boolean
        });
    }

    initCity = () => {
        // 与历史城市对比
        global.storage?.load({
            key: 'movieCityHistory'
        }).then(hisres => {
            if (hisres) {
                // 有历史记录
                this.props.dispatch({
                    type: 'cur_city',
                    cur_city: hisres[0]
                });
                this.getInfo(hisres[0].cityId);
            }
        }).catch((err) => {
            this.getInfo();
        });
    }

    showMore = () => {
        this.refMenu.setState({
            isVisible: true
        });
    }

    /* 展开更多 */
    showIntroMore = () => {
        this.setState({
            introMoreShow: true
        });
    }

    toggleIntroMore = () => {
        this.setState({
            introMoreShow: !this.state.introMoreShow
        });
    }

    /* 收起更多 */
    hideIntroMore = () => {
        this.setState({
            introMoreShow: false
        });
    }

    /* 关闭弹层（评分） */
    hideRate = () => {
        mta('InfoPopClose', 'Info', 'A');
        this.setState({
            rateShow: false
        });
    }

    /* 打开弹层（评分） */
    showRate = () => {
        mta('InfoScore', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}`);
        JDLogin.isLogin().then(() => {
            this.setState({
                rateShow: true
            });
            mta('InfoScorePopExpo', 'Info', 'A');
        }, () => {
            JDLogin.doLogin().then((re) => {
                // 开场提示
                // this._hint.hintStorage();
                this.getInfo();
            });
        }).catch((r) => {
            console.log(r);
        });
    }

    /* 关闭弹层（演员） */
    hideActor = () => {
        mta('ActorPopClose', 'Info');
        this.setState({
            actorShow: null,
            actorMovies: null
        });
    }

    /* 打开弹层（演员） */
    showActor = (actor) => {
        mta('Actor', 'Info', actor.name);
        // let { movieId } = this.state.info;
        // get('getActorMovieInfoVO', { actId: actor.actId, movieId }, true).then((res) => {
        //     console.log(res);
        //     this.setState({
        //         actorMovies: res.data,
        //         actorShow: actor
        //     });
        //     mta('ActorPopExpo', 'Info', actor.name);
        // }, (r) => {
        //     console.log(r);
        // }).catch((r) => {
        //     console.log(r);
        // });
    }

    /* 显示轮播图 */
    showSwiper = (index) => {
        mta('InfoPicture', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}`);
        this.setState({
            swiperShow: true,
            index: index
        });
    }

    /* 关闭轮播图 */
    hideSwiper = () => {
        this.setState({
            swiperShow: false
        });
    }

    /* 想看 */
    wannaSee = () => {
        const { info } = this.state;

        const type = info.type === 10 ? -1 : 10;

        const { movieId } = this.state.info;

        mta('InfoWant', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}_${info.type === 10 ? 0 : 1}`);
        JDLogin.isLogin().then(() => {
            get('userWannaSeeOrScore', { operType: type, movieId }, true).then((res) => {
                console.log(res);
                this.setState({
                    info: {
                        ...info,
                        ...{
                            type: type,
                            wannaSeenNum: info.type === 10 ? info.wannaSeenNum - 1 : info.wannaSeenNum + 1
                        }
                    }
                });
            }, (err) => {
                if (type === 10) {
                    tip('标记想看失败!');
                } else if (info.type === -1) {
                    tip('取消想看失败!');
                }
                console.log(err);
            }).catch((err) => {
                console.log(err);
            });

            if(!movieId){
                sgmReport('1001', {function_id: 'userWannaSeeOrScore',message:'缺少参数movieId'}, 3)
            }
        }, () => {
            JDLogin.doLogin().then((re) => {
                // 开场提示
                // this._hint.hintStorage();
                this.getInfo();
            });
        }).catch((err) => {
            console.log(err);
        });

    }

    /* 评分效果 */
    rate = (score) => {
        mta('InfoScorePopExpo', 'Info', `${score}_A`);
        this.setState({
            rateScore: score
        });
    }

    /* 提交评分 */
    submit = () => {
        const { rateScore: starLevel, info } = this.state;

        const { movieId } = info;

        mta('InfoPopScoreSubmit', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}_${starLevel}_A`);
        if (!starLevel) {
            tip('请进行评分！');

            return;
        }
        this.setState({
            rateShow: false
        });
        get('userWannaSeeOrScore', { flag: 10, operType: info.type, movieId, starLevel }, true).then((res) => {
            console.log(res);
            this.setState({
                info: {
                    ...this.state.info,
                    ...{
                        starLevel,
                        flag: 10
                    }
                }
            });
            tip('评分成功!');
        }, (err) => {
            console.log(err);
            tip('评分失败，请稍后重试!');
        }).catch((err) => {
            console.log(err);
        });

        if(!info.type || !movieId || !starLevel){
            sgmReport('1001', {function_id: 'userWannaSeeOrScore',message:'缺少参数operType/movieId/starLevel'}, 3)
        }
    }

    /* 跳转到视频页 */
    goMovie = (movie, isPoster) => {
        if (isPoster) {
            mta('InfoVideoBtn', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}`);
        } else {
            mta('InfoVideo', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}`);
        }
        const { info } = this.state;
        // console.log(info)

        this.context.router.toMovie({
            // 含视频id
            // movie,
            movieId: movie.movieId,
            trailerId: movie.trailerId,
            // 影片名称
            movieName: info.movieName,
            // 评分
            grade: info.grade,
            // 演员名称
            actor: info.actor,
            // 购票状态
            canPreOrder: info.canPreOrder,
            // skuid
            jSkuId: info.jSkuId
        });
    }

    /* 跳转到电影排期页 */
    goMovieSchedule = () => {
        mta('InfoMovBuy', 'Info', `${this.state.info.jSkuId}_${this.state.info.movieId}`, `${this.state.info.jSkuId}`);
        const { movieId } = this.state.info;
        const { scheduledPlay, from, cityId, cityPy, cityName, fullCityPy} = this.props;
        //from, cityId, cityPy, cityName, fullCityPy 这些参数是为了新h5页面跳转过来后根据h5的城市信息对列表和详情进行数据改变

        this.context.router.toMovieSchedule({ 
            movieId, 
            scheduledType: +scheduledPlay ? 3 : null,
            cityId,
            from,
            cityPy, 
            cityName, 
            fullCityPy
        });
    }

    /* 获取影片信息 */
    getInfo(cId) {
        this.setState({
            hasError: false,
            isLoading: true
        });
        const { movieId, collection } = this.props;

        const cityId = cId || this.props.cityId || this.props.cur_city.cityId;

        if(!cityId || !movieId){
            sgmReport('1001', {function_id: 'getMovieDetailVO',message:'缺少参数cityId/movieId'}, 3)
        }

        // let msg = `${res.data.actor}主演 `;
        // msg += res.data.starLevel ? `评分：${res.data.starLevel}分` : '';
        // msg += res.data.starLevel ? `想看：${getNum(res.data.wannaSeenNum)}人` : '';
        // let shareInfo = {
        //     url: `https://m-movie.jd.com/va/movieInfoNew/${res.data.movieId}?jdreactkey=JDReactMovie&jdreactmodule=JDReactMovie&rn_transparentenable=true&rn_routerName=movieDetail&rn_movieId=${res.data.movieId}&rn_cityId=${cityId}`,
        //     title: `电影【${res.data.movieName}】京东购票更优惠`,
        //     msg,
        //     logo: res.data.jdPicUrl
        // };
        // res.data.actors && res.data.actors.length && res.data.actors.sort((a, b) => b.role - a.role);
        // this.setState({
        //     info: res.data,
        //     isLoading: false,
        //     shareInfo
        // }, () => {
        //     const { movieId } = this.state.info;
        //     mtaPV('Info', movieId);
        // });
        // console.log(shareInfo, '影片详情分享信息')

        // 路径传过来的id优先当前默认id

        return get('getMovieDetailVO', { movieId, cityId, uid: global.uuid }, true).then((res) => {
            console.log(res);
            /* 分享信息 */
            // 带促销的分享信息
            // let shareTxt = [
            //     `来京东选座购票立减"${res.data.a}元"`,
            //     `'京东电影新用户购票立减"${res.data.a}元" 看电影，上京东！'`,
            //     `京东特惠价"${res.data.a}元" 看电影，上京东！`,
            // ]
            let msg = `${res.data.actor}主演 `;

            msg += res.data.starLevel ? `评分：${res.data.starLevel}分` : '';
            msg += res.data.starLevel ? `想看：${getNum(res.data.wannaSeenNum)}人` : '';
            const shareInfo = {
                url: `https://h5-movie.jd.com/movieDetail?movieId=${res.data.movieId}`,
                title: `电影【${res.data.movieName}】京东购票更优惠`,
                msg,
                logo: res.data.jdPicUrl
            };

            res.data.actors && res.data.actors.length && res.data.actors.sort((a, b) => b.role - a.role);
            window.jdShare?.setShareInfo({
                title: `电影【${res.data.movieName}】京东购票更优惠`,
                content: msg,
                url: window.location.href,
                img: 'https://storage.jd.com/ltmovie/movieLogo.jpg',
                channel: '',
                callback: null
            });
            this.setState({
                info: res.data,
                isLoading: false,
                shareInfo
            }, () => {
                const { type } = this.state.info;

                if (collection == 1 && type !== 10) {
                    this.wannaSee();
                }
            });
            console.log(shareInfo, '影片详情分享信息');
            if(res.data && res.data.stagePicInfo && res.data.stagePicInfo.length){
                const hasEmpty = res.data.stagePicInfo.some(item =>  !item.normalUrl || !item.minUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'getMovieDetailVO',message:'返回数据缺少图片地址！'}, 3)
                }
            }
            if(res.data && res.data.trailerInfoVOS && res.data.trailerInfoVOS.length){
                const hasEmpty = res.data.trailerInfoVOS.some(item =>  !item.jdTrailerImgUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'getMovieDetailVO',message:'返回数据缺少图片地址！'}, 3)
                }
            }
        }, (err) => {
            console.log(err);
            this.setState({
                isLoading: false,
                hasError: true
            });
        }).catch((err) => {
            console.log(err);
            this.setState({
                isLoading: false,
                hasError: true
            });
        });
    }

    setTitle = (title) => {
        document.title = title;
    }
}

MovieDetail.defaultProps = {
    movieId: 78163
};

MovieDetail.contextTypes = {
    router: PropTypes.object
};

const img = {
    heart: require('../img/movie-detail/heart.png'),
    heart_red: require('../img/movie-detail/heart-red.png'),
    star: require('../img/movie-detail/star.png'),
    play: require('../img/movie-detail/play.png'),
    close: require('../img/movie-detail/close.png')
};

const select = (state) => {
    const props = state.index;

    return {
        userPin: props.userPin,
        cur_city: props.cur_city
    };
};

export default connect(select, null, null, { withRef: true })(MovieDetail);
